import { render, staticRenderFns } from "./FilterExchangeFiltered.vue?vue&type=template&id=bb188a9e"
import script from "./FilterExchangeFiltered.vue?vue&type=script&lang=ts"
export * from "./FilterExchangeFiltered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports